(function($) {

	'use strict';

	var init = function() {
		toogleNav();
		initLangSwitcher();
	};

	var toogleNav = function(){

		//Toggle the all nav on mobile
		$('#toggleNav').click(function(){

			$(this).toggleClass('active');
			$('.mainHeader__nav').toggleClass('active');

		});

		//Toggle the sub nav on mobile
		$('.menu-item-has-children > a').click(function(e){

			//if($(window).width() < 992){

				e.preventDefault();

				var $menuItem = $(this).parent().find('.sub-menu');

				if($menuItem.hasClass('active')){

					$('.sub-menu').removeClass('active');

				}else{

					$('.sub-menu').removeClass('active');

					$menuItem.addClass('active');

				}

			//}

		});
	};

	var initLangSwitcher = function(){

		$('.lang-switcher > .lang-switcher__item:not(.current)').each(function() {
			$(this).appendTo($(this).parent().find('.lang-switcher__select'));
		});

		$('.lang-switcher').click(function() {
			$(this).closest('.lang-switcher').toggleClass('active');
		});

		$('.lang-switcher__select').css('max-height', ($('.lang-switcher__item:visible').outerHeight() + 4) * $('.lang-switcher__select').first().find('> .lang-switcher__item:not(.current)').length);

		/*
		$('.langSwitcher__select').on('change', function(){
			if($(this).val()){
				window.location = $(this).val();
			}
		});
		*/
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
